import { render, staticRenderFns } from "./CalendarTypeTab.vue?vue&type=template&id=1bc6ba66&"
import script from "./CalendarTypeTab.vue?vue&type=script&lang=js&"
export * from "./CalendarTypeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports